import { create } from 'zustand'

const useStore = create((set, get) => ({
  // Auth state
  user: null,
  session: null,
  isAuthenticated: false,
  
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setSession: (session) => set({ session }),
  logout: () => set({ user: null, session: null, isAuthenticated: false }),

  // Roadmap state
  currentRoadmap: null,
  roadmaps: [],
  communityRoadmaps: [],
  
  setCurrentRoadmap: (roadmap) => set({ currentRoadmap: roadmap }),
  addRoadmap: (roadmap) => set((state) => ({ 
    roadmaps: [...state.roadmaps, roadmap] 
  })),
  updateRoadmap: (id, updates) => set((state) => ({
    roadmaps: state.roadmaps.map(r => r.id === id ? { ...r, ...updates } : r),
    currentRoadmap: state.currentRoadmap?.id === id 
      ? { ...state.currentRoadmap, ...updates } 
      : state.currentRoadmap
  })),
  deleteRoadmap: (id) => set((state) => ({
    roadmaps: state.roadmaps.filter(r => r.id !== id),
    currentRoadmap: state.currentRoadmap?.id === id ? null : state.currentRoadmap
  })),
  setRoadmaps: (roadmaps) => set({ roadmaps }),
  setCommunityRoadmaps: (roadmaps) => set({ communityRoadmaps: roadmaps }),

  // Chat state
  chatMessages: [],
  isChatOpen: false,
  
  addChatMessage: (message) => set((state) => ({
    chatMessages: [...state.chatMessages, message]
  })),
  clearChat: () => set({ chatMessages: [] }),
  toggleChat: () => set((state) => ({ isChatOpen: !state.isChatOpen })),
  setIsChatOpen: (isOpen) => set({ isChatOpen: isOpen }),

  // Onboarding state
  onboardingData: {
    topic: '',
    currentLevel: '',
    weeklyHours: 0,
    deadline: 0,
    learningStyle: '',
    preferences: '',
    constraints: ''
  },
  
  updateOnboardingData: (data) => set((state) => ({
    onboardingData: { ...state.onboardingData, ...data }
  })),
  resetOnboardingData: () => set({
    onboardingData: {
      topic: '',
      currentLevel: '',
      weeklyHours: 0,
      deadline: 0,
      learningStyle: '',
      preferences: '',
      constraints: ''
    }
  }),

  // UI state
  isLoading: false,
  error: null,
  
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Google Drive state
  driveConnected: false,
  driveToken: null,
  
  setDriveConnected: (connected) => set({ driveConnected: connected }),
  setDriveToken: (token) => set({ driveToken: token }),
}))

export default useStore
